import { isValidNumberForRegion as _isValidNumberForRegion } from 'libphonenumber-js/custom';

const metadata = require('./metadata.custom.json');

function call(this: any, func: any, _arguments: any) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(metadata);
  return func.apply(this, args);
}

export function isValidNumberForRegion(a: any, b: any) {
  return call(_isValidNumberForRegion, arguments);
}
